const About = () => {
  return (
    <div>
      <h4>Version 0.0.2</h4>
    </div>
  )
}

export default About
